import ReferralPartnerList from './ReferralPartnerList';

export default ReferralPartnerList;
